module.exports = __webpack_public_path__ + "img/9.94626c37.jpg";